<template>
  <v-dialog v-model="newCompanyModalVisible" max-width="700px" @keydown.enter="addItem" class="ma-0 pa-0">
    <!--<v-btn slot="activator" color="#000000" dark class="add-button mb-2">Lisää tuote</v-btn>-->
    <v-card class="ma-0 pa-0">
      <v-container grid-list-md class="pt-2 pb-0 add-product-container">
        <v-row wrap class="">
          <v-col cols="12" class="mt-3">
            <span class="headline">Lisää yrityksen tiedot</span>
          </v-col>
          <v-col cols="4" class="pt-2 pb-0">
            <v-autocomplete
              label="Myyjä"
              class="pa-0 mt-0"
              v-model="newCompany.salesperson"
              :items="getSalespersons"
              persistent-hint
              hide-details
              item-text="text"
              item-value="id"
            />
          </v-col>
          <v-col cols="4" class="pt-2">
            <v-text-field 
              v-model="newCompany.companyName" 
              label="Yrityksen nimi*" 
              :error-messages="errors.companyName"
              @keyup="v => v !== '' ?  errors.companyName = '' :  ''"
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="4" class="pt-2">
            <v-text-field 
              v-model="newCompany.companyId" 
              label="Y-tunnus" 
              required 
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="6" class="pt-2">
            <v-text-field 
              v-model="newCompany.deliveryAddress" 
              label="Toimitusosoite*"
              :error-messages="errors.deliveryAddress" 
              required 
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="2" class="pt-2">
            <v-text-field 
              v-model="newCompany.deliveryPostalCode" 
              label="Postikoodi*"
              :error-messages="errors.deliveryPostalCode" 
              required 
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="2" class="pt-2">
            <v-text-field 
              v-model="newCompany.deliveryCity" 
              label="Toimipaikka*"
              :error-messages="errors.deliveryCity" 
              required 
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="2" class="pt-2">
            <v-text-field 
              v-model="newCompany.deliveryCountry" 
              label="Maa*"
              :error-messages="errors.deliveryCountry" 
              required 
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="6" class="pt-2">
            <v-text-field 
              v-model="newCompany.paymentTerm" 
              label="Maksuehto"
              :error-messages="errors.paymentTerm" 
              required 
              dense
              hide-details>
            </v-text-field>
          </v-col>
           <v-col cols="6" class="pt-2">
            <v-text-field 
              v-model="newCompany.billingReferenceDetails" 
              label="Viite"
              :error-messages="errors.billingReferenceDetails" 
              required 
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="6" md="4" class="pr-3 pb-0 pt-2">
            <v-autocomplete
              class="pa-0"
              v-model="newCompany.billingFormat"
              :items="getBillingFormats"
              :error-messages="errors.billingFormat"
              placeholder="Laskutusformaatti"
              persistent-hint
              item-text="fi"
              item-value="id"
            />
          </v-col>
          <v-col class="text-left text-left pb-0 pt-1" cols="12" md="8" v-if="newCompany.billingFormat === 'paper'">
            <v-checkbox 
              label="Eri laskutusosoite?"
              v-model="newCompany.differentBillingAddress" 
              class=" pa-0" />
          </v-col>
          <v-col cols="6" md="4" v-if="newCompany.billingFormat === 'eInvoice'" class="pr-3 pt-2">
            <v-text-field
              class="pa-0"
              label="Verkkolaskutusosoite"
              placeholder=" "
              :error-messages="errors.eBillingAddress"
              v-model="newCompany.eBillingAddress"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="4" v-if="newCompany.billingFormat === 'eInvoice'" class="pr-3 pt-2">
            <!-- <v-text-field
              class="pa-0"
              label="Operaattori"
              placeholder=" "
              :error-messages="errors.eBillingOperator"
              v-model="newCompany.eBillingOperator"
            ></v-text-field> -->
            <v-autocomplete
              class="pa-0"
              v-model="newCompany.eBillingOperator"
              :items="settings.eBillingOperators"
              label="Operaattori"
              item-text="name"
              item-value="id"
            />
          </v-col>
          <v-col class="text-left pr-3 pt-0" cols="12" md="4" v-if="newCompany.billingFormat === 'email'">
            <v-checkbox 
              label="Onko laskuille eri sähköposti kuin tilaajan sähköposti?"
              v-model="newCompany.differentBillingEmail" 
              class="avecor-dialog-checkbox pa-0"
              />
          </v-col>
          <v-col cols="12" md="4" v-if="newCompany.differentBillingEmail" class="pr-3">
            <v-text-field
              class="pa-0"
              label="Laskuille sähköpostiosoite"
              :error-messages="errors.billingEmail"
              placeholder=" "
              v-model="newCompany.billingEmail"
              ></v-text-field>
          </v-col>
          
          <v-col cols="6" md="6" v-if="newCompany.differentBillingAddress" class="pr-3 pt-2">
            <v-text-field
              class="pa-0"
              label="Laskutusosoite"
              placeholder=" "
              v-model="newCompany.billingAddress"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="2" v-if="newCompany.differentBillingAddress" class="pr-3 pt-2">
            <v-text-field
              class="pa-0"
              label="Postikoodi"
              placeholder=" " 
              v-model="newCompany.billingPostalCode"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="2" v-if="newCompany.differentBillingAddress" class="pr-3 pt-2">
            <v-text-field
              class="pa-0"
              label="Toimipaikka"
              placeholder=" " 
              v-model="newCompany.billingCity"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2" v-if="newCompany.differentBillingAddress" class="pr-3 pt-2">
            <v-text-field
              class="pa-0"
              label="Maa"
              placeholder=" " 
              v-model="newCompany.billingCountry"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters class="">
          <v-col class="text-left pr-3 pt-2 mt-0" cols="12" md="6" v-if="newCompany.billingFormat">
            <v-checkbox 
              label="Varastoasiakas (oma shopify kauppa)?"
              v-model="newCompany.customerProductsWarehoused" 
              class="mt-0 pa-0"
              dense
              style="font-size:16px !important;"
              />
          </v-col>
          <v-col class="text-left pr-3 pt-0 mt-0" cols="12" md="6" v-if="newCompany.customerProductsWarehoused">
            <v-text-field
              class="pa-0 mt-0"
              label="Asiakkaan shopify tag (esim. y_demo_oy)"
              placeholder=" " 
              v-model="newCompany.shopifyCustomerIdTag"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters class="">
          <v-col class="text-left pr-3 pt-0 mt-0" cols="12" md="12" >
            <v-textarea 
              single-line 
              rows=1
              :auto-grow="true" 
              v-model="newCompany.companyComments" 
              dense 
              label="Yrityksen lisätiedot" 
              hide-details>
            </v-textarea>
            
          </v-col>
        </v-row>
        <v-row no-gutters class="pt-3">

          <!-- KONTAKTI -->
          <v-col cols="12" class="pt-2 mt-3" style="border-top:1px solid #ccc;"><!-- style="border-top:1px solid #ccc;" -->
            <span class="headline">Lisää kontaktin tiedot</span>
          </v-col>
          <v-col cols="6" class="pt-2 pr-6">
            <v-text-field 
              v-model="newContact.firstName" 
              label="Etunimi" 
              required
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="6" class="pt-2">
            <v-text-field 
              v-model="newContact.lastName" 
              label="Sukunimi" 
              required
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="6" class="pt-2 pr-6">
            <v-text-field 
              v-model="newContact.phone" 
              label="Puhelinnumero" 
              required
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="6" class="pt-2">
            <v-text-field 
              v-model="newContact.email" 
              label="Sähköpostiosoite" 
              required
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="12" class="pt-2">
            <v-textarea 
              single-line 
              rows=2
              :auto-grow="true" 
              v-model="newContact.comments" 
              dense 
              label="Kontaktin lisätiedot" 
              hide-details>
            </v-textarea>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions class="pb-4">
        <v-spacer></v-spacer>
        <v-btn color="avecor-button-global add-button mb-2 mr-1" outlined small @click="close">Peruuta</v-btn>
        <v-btn color="avecor-button-global add-button mb-2" outlined small @click="addItem" >Lisää</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapFields } from 'vuex-map-fields'

export default {
    props:[],
    data: () => ({
      autogrow:true,
      editedIndex: -1,
      newCompany: {
        companyName:'',
        companyId:'',
        paymentTerm:"14 päivää netto",
        deliveryAddress:'',
        deliveryPostalCode:'',
        deliveryCity:'',
        deliveryCountry:'Finland',
        billingFormat:'eInvoice',
        billingEmail: '',
        eBillingAddress: '',
        eBillingOperator: '',
        clientPrintDetailsEmail: '',
        differentBillingEmail: false,
        differentBillingAddress: false,
        billingAddress:'',
        billingPostalCode:'',
        billingCity:'',
        billingCountry:'Finland',
        salesperson:'',
        customerProductsWarehoused:false,
        shopifyCustomerIdTag:'',
        companyComments:''
      },
      defaultCompany: {
        companyName:'',
        companyId:'',
        paymentTerm:"14 päivää netto",
        deliveryAddress:'',
        deliveryPostalCode:'',
        deliveryCity:'',
        deliveryCountry:'Finland',
        billingFormat:'eInvoice',
        billingEmail: '',
        eBillingAddress: '',
        eBillingOperator: '',
        clientPrintDetailsEmail: '',
        differentBillingEmail: false,
        differentBillingAddress: false,
        billingAddress:'',
        billingPostalCode:'',
        billingCity:'',
        billingCountry:'Finland',
        salesperson:'',
        customerProductsWarehoused:false,
        shopifyCustomerIdTag:'',
        companyComments:''
      },
      newContact: {
        firstName: "",
        lastName: "", 
        phone: '',
        email: '',
        comments: '',
      },
      defaultContact: {
        firstName: "",
        lastName: "", 
        phone: '',
        email: '',
        comments: '',
      },
      errors: {
          billingEmail:'',
          companyName:"",
          deliveryAddress:"",
          deliveryAddress:"",
          deliveryPostalCode:"",
          deliveryPostalCity:"",
          deliveryPostalCountry:"",
          eBillingOperator: '',
          eBillingAddress: '',
          firstName:"",
          lastName:"",
          clientPhone:"",
          clientEmail:"",
          clientPrintDetailsEmail:"",
          samplePackage:"",
          firstName: "",
          lastName: "", 
          phone: '',
          email: '',
          comments: '',
        }
       
    }),
    watch: {
      
    },
    mounted() {
      if(this.staff[this.user.uid] && this.staff[this.user.uid].role === 'sales') {
        this.defaultCompany.salesperson = this.user.uid
        this.newCompany.salesperson = this.user.uid
      }
    },

    computed: {
      getSalespersons(){
        var staff = this.staff
        var salespersons = []
        Object.keys(this.staff).map(function(key, index) {
          var s = staff[key]
          if(s.role === 'sales' || s.role === 'ceo' || s.id ==='RqjgIwdXWzXqCR2MOVr1etp2iY22' || s.id ==='p2VRFkTz4JUzqkGoTPUt4CWQAxa2') salespersons.push({text:s.firstName, id:s.id})
          return {...s}
        })
        return salespersons
      },
      getBillingFormats(){
        var billingFormats = this.settings.billingFormats
        return Object.keys(this.settings.billingFormats).reduce(function(result, key) {
          result.push({...billingFormats[key]});
          return result;
        }, []);
      },
      ...mapFields({
        settings:"settings",
        staff:"staff.staff",
        user:'user',
        newCompanyModalVisible:"modals.company.new.visible",
      })
    },
    created () {},
    methods: {
      customFormatter(date) {
        var da = dateFormat(date, "yyyy-mm-dd")
        return da
      },
      close () {
        this.newCompanyModalVisible = false
        setTimeout(() => {
          this.newCompany = Object.assign({}, this.defaultCompany)
          this.newContact = Object.assign({}, this.defaultContact)
          this.editedIndex = -1
        }, 300)
      },
      async addItem () {
        if(this.newCompany.companyName.trim() === '') {this.errors.companyName = "Yrityksen nimi lisättävä"; return}


        var companyDBId = await this.$store.dispatch('company/set', {
          ...this.newCompany
        })
        var contactData = {
          companyId:companyDBId,
          firstName:this.newContact.firstName,
          lastName:this.newContact.lastName,
          phone:this.newContact.phone,
          email:this.newContact.email,
          sendConfirmation: false,
          comments:this.newContact.comments,
        }
        var contactDBId = await this.$store.dispatch('contact/set', contactData)
        .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Lisätty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        this.close()
        /* if(this.newItem.name.fi === '') {alert("Täytä nimi"); return}
        var {warehoused,...y} = this.newItem;
        const newProductId = await this.$store.dispatch('product/set', {...y,warehoused})

        var {...z} = this.newProductVariation;
        console.log(z)
        const newId = await this.$store.dispatch('productVariation/set', {...z, productId:newProductId,warehoused})

        this.close() */
      },
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/AddCompany.vue